import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requireAdmin?: boolean;
  requireSuperAdmin?: boolean;
  allowPasswordChange?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
  requireSuperAdmin = false,
  allowPasswordChange = false,
}) => {
  const { isAuthenticated, isAdmin, isSuperAdmin, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="container">
        <div className="card">
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (
    user?.must_change_password &&
    !allowPasswordChange &&
    location.pathname !== '/change-password'
  ) {
    return <Navigate to="/change-password" replace />;
  }

  if (requireSuperAdmin && !isSuperAdmin) {
    return (
      <div className="container">
        <div className="card">
          <div className="error">
            You need Super Admin privileges to access this page.
          </div>
        </div>
      </div>
    );
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="container">
        <div className="card">
          <div className="error">
            You need Admin privileges to access this page.
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
